import React,{useEffect,useState} from "react"
import The_header from "./the_header"
import { Outlet } from "react-router-dom"
import Contact from "./contact"

function Layout() {

    const [scroll, setScroll] = useState(0);
    useEffect(() => {
    const handleScroll = () => {
    setScroll(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
    window.removeEventListener("scroll", handleScroll);
    };
    }, []);

  const shrink = "h-16";

    return (
      <div className=' flex flex-col h-full min-h-screen w-full' >
        <div
            id="bottom"
            className={`bg-transparent header z-50 fixed top-0 transition duration-300 ease-in-out ${
            scroll > 100 ? shrink : ""
            }`}
            >
            <The_header />
        </div>
        <Outlet />
        <div
            id="bottom"
            className={`fixed bottom-10 z-50 right-5 transition duration-300 ease-in-out`}
            >
            <Contact />
        </div>
    </div>
    )
}

export default Layout